import assert from 'assert';

export const mergeFrames = (
  prevFrames: string[],
  newFrames: string[],
  scramble?: number[]
): string[] => {
  let unscrambledFrames: string[] = [];
  if (scramble?.length) {
    for (let i = 0; i < newFrames.length; i++) {
      unscrambledFrames.push(newFrames[scramble.indexOf(i)]!);
    }
  } else {
    unscrambledFrames = newFrames;
  }

  let interleaved: string[] = [];
  if (prevFrames.length > 0) {
    assert(unscrambledFrames.length === prevFrames.length, 'Images must be the same length');
    for (let i = 0; i < unscrambledFrames.length; i++) {
      interleaved.push(prevFrames[i]!);
      interleaved.push(unscrambledFrames[i]!);
    }
  } else {
    interleaved = unscrambledFrames;
  }
  return interleaved;
};

export const fetchImage360Url = async (
  url: string,
  seq: number,
  referer: string | undefined
): Promise<string[]> => {
  const response = await fetch(
    `/api/proxy?url=${encodeURIComponent(url + `/${seq + 1}.json?version=1`)}&referer=${encodeURIComponent(referer || '')}`
  );
  return await response.json();
};
